<template>
  <ORow fill-x stretch-x class="plot" :id="`plot_${config.id}`">
    <div class="plot-buttons">
      <v-btn icon @click="remove">
        <v-icon small>mdi-delete</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon small>mdi-clipboard-outline</v-icon>
      </v-btn>
      <v-btn icon @click="togglePin">
        <v-icon small v-if="config.isPinned">mdi-pin-off</v-icon>
        <v-icon small v-else>mdi-pin</v-icon>
      </v-btn>
    </div>
    <div style="width: 200px" class="text-body-2 ml-2">
      {{ config.toString() }}
    </div>

    <div style="flex-grow: 0; flex-shrink: 0; width: 420px">
      <PlotLine :plotId="config.id" />
    </div>

    <div class="caret-info text-body-2 ml-2">
      <div class="caret-value">{{ caretValueStr }}</div>
      <!-- <div class="caret-timestamp">{{ caretTimestampStr }}</div> -->
    </div>
  </ORow>
</template>

<script>
import PlotLine from './PlotLine.vue'
import SniffStore from './SniffStore'

export default {
  components: {
    PlotLine
  },
  props: {
    config: { required: true }
  },
  computed: {
    caretValueStr() {
      if (SniffStore.caret == null) return ''
      const val = SniffStore.caret.plotValues[this.config.id]
      if (val == null) return ''
      return `${val} (0x${val.toString(16)})`
    }
  },
  methods: {
    togglePin() {
      SniffStore.togglePin(this.config)
    },

    remove() {
      SniffStore.remove(this.config)
    },

    copyPlot() {}
  }
}
</script>

<style lang="sass">
.plot-buttons
  display: flex
  flex-flow: row nowrap
  opacity: 0
  transition: all 125ms

.plot:hover
  .plot-buttons
    opacity: 1

.caret-info
  display: flex
  flex-flow: row nowrap

  // .caret-timestamp
  //   width: 200px

  .caret-value
    font-weight: bold
    width: 120px
    text-align: right
    padding-right: 16px
</style>
